import { gql } from '@apollo/client'

import * as f from '../../../components/BPMTable/BPMInputs'
import { 
    DataMapper, 
    HideDeletionDisplayStrategy, 
    TableFieldDescription 
} from '../../../components/BPMTable/TableMapperCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import {DirectTableQueryBuilder} from "../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder";

// tableQuery movido al test de DirectTableQueryBuilder

const editMutator = gql`
    mutation modifyDestinationConverterMutation($id: String!, $destination: String!, $destinationDescription: String!) {
        modifyDestinationConverter(id: $id, destination: $destination, destinationDescription: $destinationDescription) {
            destinationConverter {
                id
            }
        }
    }
`

const newMutator = gql`
    mutation createDestinationConverterMutation($destination: String!, $destinationDescription: String!) {
        createDestinationConverter(destination: $destination, destinationDescription: $destinationDescription) {
            destinationConverter {
                id
            }
        }
    }
`

const deleteMutator = null

const unitQuery = `
    destinationConverter(id: $id) {
        id
        destination {
            id
            name
        }
        destinationDescription {
            id
            name
        }
    }
`

const DestinationConverterQueries = {tableQueryBuilder: new DirectTableQueryBuilder('allDestinationConverters'), editMutator, newMutator, deleteMutator, unitQuery}

class DestinationConverterTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "DestinationConverterTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator = this.createTableCreator(this.constructor.getId(), tableName, DestinationConverterQueries)
        tableCreator.setDisplayStrategy(new HideDeletionDisplayStrategy())
        tableCreator.setInitialSortField('destination', 'desc')
        tableCreator.addDescriptions([
            new TableFieldDescription(
                'destination',
                new DataMapper("destination.name"),
                new f.FilterDescription(new f.TextFilter("destination")),
                {label: 'Destination'}
            ),
            new TableFieldDescription(
                'destinationDescription',
                new DataMapper("destinationDescription.name"),
                new f.FilterDescription(new f.TextFilter("destinationDescription")),
                {label: 'Destination Description'}
            )
        ])

        return tableCreator
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(DestinationConverterTableCreator)

export {
    DestinationConverterTableCreator,
    DestinationConverterQueries
}
